import { Container, type ContainerProps, Paper } from "@mui/material";
import { styled } from "@mui/material/styles";

export default styled((props: Omit<ContainerProps, "component">) => (
  <Container component={Paper} {...props} />
))(({ theme }) => ({
  padding: theme.spacing(2),
  color: `${theme.palette.text.secondary}`,
}));
